import {
  Grid,
  Typography,
  Box,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import React from "react";

const AboutFees = () => {
  return (
    <Grid
      spacing={4}
      container
      sx={{
        alignItems: "center",
        justifyContent: "center",
        marginTop: "40px",
      }}
    >
      <Grid item xs={12} sm={6} md={5}>
        <Typography
          variant="h3"
          sx={{ fontWeight: "700", fontSize: "28px", marginBottom: "15px" }}
        >
          Understanding Loba marketplace fees
        </Typography>

        <iframe
          width="100%"
          height="315"
          src="https://www.youtube.com/embed/EngW7tLk6R8?si=tw5FERWnJjII6z4z"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerpolicy="strict-origin-when-cross-origin"
          allowfullscreen
        ></iframe>

        <Typography
          variant="h3"
          sx={{
            fontWeight: "400",
            fontSize: "14px",
            lineHeight: "22px",
            marginTop: "10px",
          }}
        >
          Millions of appointments are booked on Fresha each month, with 80% of
          clients returning for a second appointment
        </Typography>
        <Typography
          variant="h3"
          sx={{ fontWeight: "700", fontSize: "15px", margin: "10px 0" }}
        >
          Online booking fees
        </Typography>
        <Typography
          variant="h3"
          sx={{ fontWeight: "400", fontSize: "14px", lineHeight: "22px" }}
        >
          A transaction fee of 4.9% + 0.75 is applied to all bookings made
          online. <span style={{ color: "blue" }}></span>
        </Typography>
        <Typography
          variant="h3"
          sx={{ fontWeight: "700", fontSize: "15px", margin: "10px 0" }}
        >
          Marketplace new client fee
        </Typography>
        <Typography
          variant="h3"
          sx={{ fontWeight: "400", fontSize: "14px", lineHeight: "22px" }}
        >
          A one-time fee of 50% or a minimum 10 applies to brand new clients who
          discover your business via the Loba marketplace. The fee never applies
          to your returning clients. <span style={{ color: "blue" }}></span>
        </Typography>
        <Box
          sx={{
            background: "rgb(241 240 254)",
            padding: "5px 12px",
            marginTop: "15px",
            borderRadius: "10px",
            border: "1px solid rgb(219 218 223)",
            marginBottom: "20px",
          }}
        >
          <FormControlLabel
            control={<Checkbox defaultChecked />}
            label="I understand and accept Loba Marketplace fees"
            color="primary"
          />
        </Box>
      </Grid>
    </Grid>
  );
};

export default AboutFees;
